<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h14">Acknowledgments</h1>
<p> </p>
<p>First and foremost, thank you to Raine for asking me to be a part of <span class="t2">Piece Us Back Together</span>. It has been so much fun, and it finally gave a voice to the man who was the real-life inspiration behind Matthew. Thank you to Star, Mariah, and Andrew for their friendship, support, beta-reading talents, and advice.</p>
<p><span class="t3">And as always, thank you to the wonderful staff at Dreamspinner Press, with a special thank you to Tricia, Brian, Anastasia, Cyndy, and Rose.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?24814c35